<template>
    <span class="table-row-actions" @click.stop>
        <div class="dropdown" :class="{ show: open }">
            <a href="#"
               ref="toggle"
               role="button"
               aria-haspopup="true"
               :aria-expanded="open ? 'true' : 'false'"
               class="dropdown-toggle table-row-actions__toggle"
               @click.prevent="toggle">
                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                <span class="sr-only">{{ label }}</span>
            </a>
            <div ref="menu"
                 class="dropdown-menu dropdown-menu-right table-row-actions__menu"
                 :class="{ show: open, 'is-placed': placed }"
                 @click="close">
                <slot></slot>
            </div>
        </div>
    </span>
</template>

<script>
const OPEN_EVENT = 'pj-table-row-actions-open';

export default {
    name: 'TableRowActions',
    props: {
        label: {
            type: String,
            default: 'Actions',
        },
    },
    data() {
        return {
            open: false,
            placed: false,
        };
    },
    mounted() {
        this.onAnyOpen = (event) => {
            if (event.detail !== this) {
                this.close();
            }
        };
        this.onDocumentClick = () => {
            if (this.open) {
                this.close();
            }
        };
        this.onScroll = () => {
            if (this.open) {
                this.close();
            }
        };
        window.addEventListener(OPEN_EVENT, this.onAnyOpen);
        document.addEventListener('click', this.onDocumentClick);
        window.addEventListener('scroll', this.onScroll, true);
        window.addEventListener('resize', this.onScroll);
    },
    beforeDestroy() {
        window.removeEventListener(OPEN_EVENT, this.onAnyOpen);
        document.removeEventListener('click', this.onDocumentClick);
        window.removeEventListener('scroll', this.onScroll, true);
        window.removeEventListener('resize', this.onScroll);
    },
    methods: {
        toggle() {
            if (this.open) {
                this.close();
                return;
            }

            window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: this }));
            this.placed = false;
            this.open = true;
            this.$nextTick(() => this.placeMenu());
        },
        close() {
            this.open = false;
            this.placed = false;
        },
        placeMenu() {
            const toggle = this.$refs.toggle;
            const menu = this.$refs.menu;

            if (!toggle || !menu || !this.open) {
                return;
            }

            const rect = toggle.getBoundingClientRect();
            const menuWidth = menu.offsetWidth;
            const menuHeight = menu.offsetHeight;
            const gap = 4;
            let top = rect.bottom + gap;
            let left = rect.right - menuWidth;

            if (top + menuHeight > window.innerHeight && rect.top > menuHeight) {
                top = rect.top - menuHeight - gap;
            }

            left = Math.max(8, Math.min(left, window.innerWidth - menuWidth - 8));

            menu.style.top = `${top}px`;
            menu.style.left = `${left}px`;
            menu.style.right = 'auto';
            this.placed = true;
        },
    },
};
</script>

<style>
.table-row-actions__toggle {
    color: #6e6b7b;
    font-size: 1.15rem;
    line-height: 1;
    padding: 0.35rem 0.6rem;
    box-shadow: none !important;
}

.table-row-actions__toggle::after {
    display: none;
}

.table-row-actions__toggle:hover,
.table-row-actions__toggle:focus,
.table-row-actions__toggle[aria-expanded="true"] {
    color: #00cfe8;
}

.table-row-actions .dropdown.show > .table-row-actions__menu {
    position: fixed;
    z-index: 2000;
    display: block;
    margin: 0;
    min-width: 10rem;
    transform: scale(1, 1);
}

.table-row-actions .dropdown.show > .table-row-actions__menu:not(.is-placed) {
    visibility: hidden;
}

.table-row-actions__menu .dropdown-item i {
    margin-right: 8px;
    width: 1rem;
    display: inline-block;
    text-align: center;
}

.table-row-actions__menu .dropdown-item.text-danger,
.table-row-actions__menu .dropdown-item.text-danger i {
    color: #ea5455;
}

.table-row-actions__menu .dropdown-item.text-danger:hover,
.table-row-actions__menu .dropdown-item.text-danger:focus {
    color: #ea5455;
    background-color: rgba(234, 84, 85, 0.08);
}

.table-row-actions__menu .dropdown-item.text-danger:hover i,
.table-row-actions__menu .dropdown-item.text-danger:focus i {
    color: #ea5455;
}
</style>
